import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db, dbOschatz } from "../firebase";
import { doc, getDoc, updateDoc, runTransaction } from "firebase/firestore";
import { sendBrevoMail } from "../sendBrevoMail";
import { formatWarehouse, warehouseSlotKey } from "../warehouseTime";

function CancelBookingPage() {
  const { docId, token } = useParams();
  const navigate = useNavigate();
  const [booking, setBooking] = useState(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        // Spróbuj znaleźć booking w odpowiedniej bazie na podstawie hostname
        const isOschatz = window.location.hostname.includes('oschatz');
        const currentDb = isOschatz ? dbOschatz : db;
        const collectionId = 'euoso0pRR5PZw2wBnjOW'; // Ta sama kolekcja w obu bazach
        
        const docRef = doc(currentDb, 'pre-alerts_MIGRATED', collectionId, 'alerts', docId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.cancellation_token === token && data.isCancel !== true) {
            setBooking(data);
          } else if (data.isCancel === true) {
            setError("This booking has already been canceled.");
          } else {
            setError("Invalid cancellation link.");
          }
        } else {
          setError("Booking not found.");
        }
      } catch (err) {
        console.error("Error fetching booking:", err);
        setError("An error occurred while fetching booking data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchBooking();
  }, [docId, token]);

  const handleCancel = async () => {
    if (window.confirm("Are you sure you want to cancel this booking? This action cannot be undone.")) {
      setIsLoading(true);
      try {
        // Krok 1: Zaktualizuj status w bazie
        const isOschatz = window.location.hostname.includes('oschatz');
        const currentDb = isOschatz ? dbOschatz : db;
        const docRef = doc(currentDb, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'alerts', docId);
        await updateDoc(docRef, { isCancel: true });

        // Zwolnij lock slotu (globalny dla wszystkich typów)
        if (booking.firstDate) {
          let slotDate;
          if (booking.firstDate.seconds) {
            slotDate = new Date(booking.firstDate.seconds * 1000 + (booking.firstDate.nanoseconds || 0) / 1000000);
          } else if (typeof booking.firstDate === 'string') {
            slotDate = new Date(booking.firstDate);
          } else if (booking.firstDate instanceof Date) {
            slotDate = booking.firstDate;
          }

          if (slotDate) {
            const slotKey = warehouseSlotKey(slotDate);
            const lockRef = doc(currentDb, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'locks', slotKey);
            await runTransaction(currentDb, async (tx) => {
              const snap = await tx.get(lockRef);
              if (!snap.exists()) return;
              const count = snap.data().count || 0;
              if (count <= 1) {
                tx.delete(lockRef);
              } else {
                tx.update(lockRef, { count: count - 1, updatedAt: Date.now() });
              }
            });
          }
        }

        // Krok 2: Wyślij e-mail z potwierdzeniem anulowania
        // Konwertuj firstDate - może być Timestamp lub ISO string
        let dateMs;
        if (booking.firstDate && booking.firstDate.seconds) {
          // Firestore Timestamp
          dateMs = booking.firstDate.seconds * 1000 + (booking.firstDate.nanoseconds || 0) / 1000000;
        } else if (booking.firstDate && typeof booking.firstDate === 'string') {
          // ISO string
          dateMs = new Date(booking.firstDate).getTime();
        } else if (booking.firstDate instanceof Date) {
          // Date object
          dateMs = booking.firstDate.getTime();
        } else {
          dateMs = Date.now();
        }
        
        const date = formatWarehouse(new Date(dateMs), 'yyyy-MM-dd HH:mm');
        const emailObj = {
            email: booking.email,
            id: booking.id || docId,
            from: window.location.hostname.includes('oschatz') ? "slamfirebaseproject@gmail.com" : "slamhoyerswerda@gmail.com",
            my_html: `<h3>Booking Canceled: Pre-Alert no #${booking.id}</h3><br/><br/><p>Dear User,</p><p>This is a confirmation that your booking for <strong>${date}</strong> has been successfully canceled at your request.</p><p>Best regards,<br>Slam Poland</p>`,
        };
        await sendBrevoMail(emailObj);
        
        setMessage("Your booking has been successfully canceled. A confirmation email has been sent.");
        setBooking(null);
      } catch (err) {
        console.error("Error during cancellation:", err);
        setError("Failed to cancel the booking. Please try again.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (isLoading) return <div style={{ textAlign: 'center', padding: '2rem' }}>Loading...</div>;

  return (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h1>Cancel Booking</h1>
      {error && <p style={{ color: 'red', fontWeight: 'bold' }}>{error}</p>}
      {message && <p style={{ color: 'green', fontWeight: 'bold' }}>{message}</p>}
      
      {booking && (
        <div>
          <p>Do you want to cancel the following booking?</p>
          <p><strong>Pre-Alert no #{booking.id}</strong></p>
          <p><strong>Date:</strong> {formatWarehouse(booking.firstDate, 'dd.MM.yyyy HH:mm')}</p>
          
          {/* --- ZMIANA: Poprawiony layout przycisków --- */}
          <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
            <button 
              onClick={handleCancel} 
              style={{ width: '200px', padding: '10px 20px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
            >
              Yes, cancel booking
            </button>
            <button 
              onClick={() => navigate('/')} 
              style={{ width: '200px', padding: '10px 20px' }}
            >
              No, go back
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CancelBookingPage;